import script from "./ChatMgButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMgButton.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMgButton.vue?vue&type=style&index=0&id=7876d1f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7876d1f7"]])

export default __exports__